import type { EndpointDefinition } from "../_sdk/types/common";

export const apiName = "sharedThemes";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getSharedTheme: {
        method: "GET",
        route: "/shared-themes/:id",
    },
    updateSharedTheme: {
        method: "PUT",
        route: "/shared-themes/:id",
    },
    deleteSharedTheme: {
        method: "DELETE",
        route: "/shared-themes/:id",
    },
    createSharedTheme: {
        method: "POST",
        route: "/shared-themes/:id",
    },
};
